import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { IncidentCategoryDto, IncidentSubCategoryDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-incident-sub-category-container',
  templateUrl: './incident-sub-category-container.component.html',
  styleUrls: ['./incident-sub-category-container.component.scss'],
})
export class IncidentSubCategoryContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentcategorys$: Observable<IncidentCategoryDto[]>;
  incidentsubcategorys$: Observable<IncidentSubCategoryDto[]>;
  loading: boolean;
  isLoadingIncidentCategory$: Observable<boolean>;
  isLoadingIncidentSubCategory$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingIncidentCategory$ = this.gatwayFacade.isLoadingGateway(
      'IncidentCategory'
    );
    this.isLoadingIncidentSubCategory$ = this.gatwayFacade.isLoadingGateway(
      'IncidentSubCategory'
    );

    this.incidentcategorys$ = this.gatwayFacade.loadGateway('IncidentCategory');
    this.incidentsubcategorys$ = this.gatwayFacade.loadGateway(
      'IncidentSubCategory'
    );
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIncidentSubCategory(deletedValue: any) {
    this.gatwayFacade.remove('IncidentSubCategory', deletedValue);
  }

  // this method control both the create and update

  onSubmitIncidentSubCategory(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentSubCategorys;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllIncidentSubCategory = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllIncidentSubCategory.push(pullData[i]);
      }
    }

    // check if the addAllIncidentSubCategory array is not empty, then dispatch the data to the store
    if (addAllIncidentSubCategory.length > 0) {
      this.gatwayFacade.add('IncidentSubCategory', addAllIncidentSubCategory);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('IncidentSubCategory', allUpdates, ['id']);
    }
  }
}
